import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { types, getRoot, getParent } from 'mobx-state-tree';
import { ALLOCATION_METHOD, BILL_FREQUENCY, PAID_BY_TO_VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import moment from 'moment';
export const UtilityTypeModel = types.model({
  utilityTypeId: types.string,
  utilityTypeName: types.string,
  isCustom: types.optional(types.boolean, false)
}).actions(store => {
  return {
    setUtilityTypeId(val) {
      if (store.isCustom) store.utilityTypeId = val;
    }
  };
});
export const UtilityProviderModel = types.model({
  id: types.maybeNull(types.string),
  utilityProviderId: types.optional(types.string, ''),
  utilityProviderName: types.optional(types.string, ''),
  // Declared or MST strips it, and the credential gate reads it as "no scraper covers this".
  scraperProviderKey: types.maybeNull(types.string),
  website: types.optional(types.maybeNull(types.string), ''),
  billsDownloadNeeded: types.optional(types.boolean, false),
  isCustom: types.optional(types.boolean, false),
  isAppAutomationEnabled: types.maybeNull(types.boolean),
  // NOTE: Used only for new billing template creation
  utilities: types.maybeNull(types.array(UtilityTypeModel))
}).actions(store => {
  return {
    setUtilityProviderName(val) {
      if (store.isCustom) store.utilityProviderName = val;
    },
    setWebsite(val) {
      if (store.isCustom) store.website = val;
    },
    setUtilityProviderId(val) {
      if (getParent(store).propertyUtilityId === 'NEW_TEMPLATE' && store.isCustom) store.utilityProviderId = val;
    },
    parseProviderFromSearch(data) {
      store.utilityProviderId = data === null || data === void 0 ? void 0 : data.id;
      store.utilityProviderName = data === null || data === void 0 ? void 0 : data.name;
      store.website = data === null || data === void 0 ? void 0 : data.website;
      store.billsDownloadNeeded = data === null || data === void 0 ? void 0 : data.billsDownloadNeeded;
      store.isCustom = data === null || data === void 0 ? void 0 : data.isCustom;
      store.isAppAutomationEnabled = data === null || data === void 0 ? void 0 : data.isAppAutomationEnabled;
      store.utilities = (data === null || data === void 0 ? void 0 : data.utilities) !== null ? data === null || data === void 0 ? void 0 : data.utilities.map(item => _objectSpread(_objectSpread({}, item), {}, {
        utilityTypeName: item.name
      })) : data === null || data === void 0 ? void 0 : data.utilities;
    },
    setGenericUtilities(data) {
      if (getParent(store).propertyUtilityId === 'NEW_TEMPLATE' && store.isCustom) {
        store.utilities = data;
      } else return;
    }
  };
});

// Note: Common for provider
export const UtilityInfoModel = types.model({
  utilityId: types.string,
  utilityTypeId: types.string,
  utilityTypeName: types.string,
  providerName: types.string,
  defaultAllocationMethod: types.optional(types.string, ALLOCATION_METHOD.ByOccupancy),
  paidBy: types.optional(types.string, PAID_BY_TO_VACANT_UNIT_ALLOCATIONS.Owner),
  //'Owner'
  defaultVacantUnitUsage: types.maybeNull(types.string),
  // VACANT_UNIT_USAGE.NoUsage), // 'NoUsage',
  cad: types.boolean,
  lastUpdateTime: types.optional(types.number, moment().toDate().getTime()),
  // NOTE: technical param for old utilities
  id: types.maybeNull(types.string)
});
export const BillingTemplateModel = types.model({
  propertyUtilityId: types.optional(types.string, 'NEW_TEMPLATE'),
  provider: types.optional(UtilityProviderModel, {}),
  utilityTypes: types.optional(types.array(UtilityTypeModel), []),
  billFrequencyType: types.optional(types.string, BILL_FREQUENCY.Monthly),
  allocationMethod: types.optional(types.string, ALLOCATION_METHOD.ByOccupancy),
  commonAreaDeduction: types.maybeNull(types.number),
  vacantUnitAllocation: types.optional(types.string, VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
  vacantUnitUsage: types.optional(types.string, VACANT_UNIT_USAGE.NoUsage),
  vacantUnitUsageLimit: types.maybeNull(types.number),
  vacantUnitOccupantsCount: types.maybeNull(types.number),
  goodWillDeduction: types.maybeNull(types.optional(types.number, 5)),
  lastUpdateTime: types.optional(types.number, moment().toDate().getTime())
}).actions(store => {
  return {
    setBillFrequencyType(value) {
      store.billFrequencyType = value;
    },
    setAllocationMethod(value) {
      store.allocationMethod = value;
    },
    setCommonAreaDeduction(value) {
      store.commonAreaDeduction = value;
    },
    setVacantUnitAllocation(value) {
      store.vacantUnitAllocation = value;
    },
    setVacantUnitUsage(value) {
      store.vacantUnitUsage = value;
    },
    setVacantUnitUsageLimit(value) {
      store.vacantUnitUsageLimit = value;
    },
    setVacantUnitOccupantsCount(value) {
      store.vacantUnitOccupantsCount = value;
    },
    setGoodWillDeduction(value) {
      store.goodWillDeduction = value;
    },
    // NOTE: Methods only for adding new billing template
    configureProviderModelForNewTemplate(data) {
      if (store.propertyUtilityId !== 'NEW_TEMPLATE') return;
      store.provider.parseProviderFromSearch(data);
    },
    updateProviderModalInitials(data) {
      if (store.propertyUtilityId !== 'NEW_TEMPLATE' || !data) return;
      store.allocationMethod = data.defaultAllocationMethod;
      store.vacantUnitAllocation = PAID_BY_TO_VACANT_UNIT_ALLOCATIONS[data.paidBy];
      store.vacantUnitUsage = data.defaultVacantUnitUsage;
      store.vacantUnitUsageLimit = data.defaultVacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? 30 : 10;
      store.commonAreaDeduction = data.cad ? 5 : 0;
    },
    addUtilityType(data) {
      // if (store.propertyUtilityId !== 'NEW_TEMPLATE') return;
      if (data.id.startsWith('customUtilityId_')) {
        // Note: handling new custom utility type
        store.utilityTypes.push(_objectSpread(_objectSpread({}, data), {}, {
          utilityTypeId: data.id,
          utilityTypeName: data.inputName,
          isCustom: data.isCustom
        }));
        return;
      }
      store.utilityTypes.push(data);
    },
    removeUtilityType(data) {
      if (data === 'all') {
        store.utilityTypes = [];
      } else {
        const matchIndex = store.utilityTypes.findIndex(utType => utType.utilityTypeId === data.utilityTypeId);
        if (matchIndex !== -1) {
          store.utilityTypes.splice(matchIndex, 1);
        }
      }
    },
    // NOTE: Only custom provider billing templates
    updateUtilityTypeIdForNewCustomUtilityType(_ref) {
      let searchUtilityTypeId = _ref.searchUtilityTypeId,
        utilityTypeId = _ref.utilityTypeId;
      if (searchUtilityTypeId.startsWith('customUtilityId_')) {
        store.utilityTypes.find(utType => utType.utilityTypeId === searchUtilityTypeId).setUtilityTypeId(utilityTypeId);
      }
    }
  };
}).views(store => ({
  get utilityName() {
    if (store.utilityTypes.length === 0) {
      var _getRoot$homeDashboar;
      return (_getRoot$homeDashboar = getRoot(store).homeDashboardStore.getCurrentCompany) === null || _getRoot$homeDashboar === void 0 || (_getRoot$homeDashboar = _getRoot$homeDashboar.getOldUtilityInfoById(store.propertyUtilityId)) === null || _getRoot$homeDashboar === void 0 ? void 0 : _getRoot$homeDashboar.utilityTypeName;
    }
    return store.utilityTypes.map(i => i.utilityTypeName).join('/');
  }
}));